<template>
  <form class="t-form">
    <slot></slot>
  </form>
</template>

<script>

export default {
  name: 't-form',

  methods: {
    submit() {
      this.$emit('handle:submit');
    },
  },
};
</script>
